module.exports = __webpack_public_path__ + "img/tv-image3.55a09066.jpg";